<div class="page-content">
    <div class="page-header">
        <h1>Page d'accueil</h1>
        <div class="page-description">Bienvenue !</div>
    </div>

    <div class="page-body">
   
    </div>
</div>
